import _ from 'lodash';
import { PayloadAction } from '@ipreo/muni-shared';
import { RESET_DATA } from '../actions';
import {
  USTREASURIES_LOAD_REQUESTED,
  USTREASURIES_LOAD_SUCCESS,
  USTREASURIES_LOAD_ERROR,
  USTREASURY_SELECTED,
  USTREASURY_EVENT_RECEIVED
} from './actions';
import { USTreasuries, USTreasury } from '../../models/us-treasury';

// tslint:disable:no-null-keyword
export interface USTreasuriesState {
  usTreasuries: USTreasuries;
  selected: USTreasury;
  loading: boolean;
  error?: string;
}

export const usTreasuryDefaultState: USTreasuriesState = {
  usTreasuries: [],
  selected: null,
  loading: false
};

export const EOD_INDICATOR = 'PD1500';

export function usTreasuriesReducer(
  state = usTreasuryDefaultState,
  action: PayloadAction<USTreasuries | USTreasury | string>
): USTreasuriesState {
  switch (action.type) {
    case USTREASURIES_LOAD_REQUESTED:
      return {
        ...state,
        loading: true
      };
    case USTREASURIES_LOAD_SUCCESS:
      return {
        ...state,
        usTreasuries: (action as PayloadAction<USTreasuries>).payload,
        selected: selectDefault(
          (action as PayloadAction<USTreasuries>).payload
        ),
        loading: false
      };
    case USTREASURIES_LOAD_ERROR:
      return {
        ...usTreasuryDefaultState,
        error: (action as PayloadAction<string>).payload,
        loading: false
      };
    case USTREASURY_SELECTED:
      return {
        ...state,
        selected: (action as PayloadAction<USTreasury>).payload
      };
    case USTREASURY_EVENT_RECEIVED:
      return updateTreasuriesStateFromEvent(
        state,
        (action as PayloadAction<USTreasury>).payload
      );
    case RESET_DATA:
      return usTreasuryDefaultState;
    default:
      return state;
  }
}

export function selectDefault(treasuries: USTreasuries): USTreasury | null {
  if (treasuries && treasuries.length) {
    return (
      _.find(treasuries, treasury => treasury.securityId === 'US10Y') ||
      treasuries[0]
    );
  } else {
    return null;
  }
}

export function updateTreasuriesStateFromEvent(
  treasuriesState: USTreasuriesState,
  treasuryEvent: USTreasury
): USTreasuriesState {
  const updatedTreasuries = treasuriesState.usTreasuries.map(storeTreasury => {
    if (storeTreasury.securityId === treasuryEvent.securityId) {
      if (treasuryEvent.current.eodType === EOD_INDICATOR) {
        // leaving this logic here in case we want to use this new
        // EOD value to update previous in the future
        return { ...storeTreasury };
      } else {
        return {
          ...treasuryEvent,
          previous: storeTreasury.previous
        };
      }
    } else {
      return { ...storeTreasury };
    }
  });
  const updatedSelectedTreasury = _.find(
    updatedTreasuries,
    (treasury: USTreasury) =>
      treasury.securityId === treasuriesState.selected.securityId
  );
  return {
    ...treasuriesState,
    usTreasuries: updatedTreasuries,
    selected: updatedSelectedTreasury
  };
}

export const getTreasuries = (state: USTreasuriesState) => state.usTreasuries;
export const getSelected = (state: USTreasuriesState) => state.selected;
export const getLoading = (state: USTreasuriesState) => state.loading;
